<template>
  <div class="venue-analysis-details">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="top-navbar-left">
                <div class="btn-back" @click="$router.push({ name: 'venueAnalysisSummary' });">
                    <font-awesome-icon :icon="['fas', 'angle-left']" />
                    Back
                </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">Venue Analysis</div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'venueAnalysisFullMap' })"
              >
                Full Details Map
              </button>
              <!--<button class="btn btn-ecdc ml-3">Export Report</button>-->
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="row">
        <transition name="fade" mode="out-in">
          <div
            v-show="toggleFilter"
            id="side-filter-col"
            class="col-lg-3"
          >
            <div class="side-filter">
              <div class="title">
                Filter
              </div>

              <div class="form-group">
                <div class="label">Area</div>
                <div class="custom-modal-select" v-b-modal.area-modal>
                  <input type="button" class="form-control" value="Select" />
                </div>

                <div class="selected-label" v-if="filter.area.length > 0">
                  FILTER:
                  <div v-for="area in filter.area" :key="area">
                    {{ areaOptions.find((x) => x.id === area).name }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="label">Category</div>
                <app-multi-select
                  :options="
                    categoryOptions.map((categoryOption) => categoryOption.id)
                  "
                  :custom-label="
                    (opt) => categoryOptions.find((x) => x.id === opt).category
                  "
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :placeholder="'-- All Category --'"
                  v-model="filter.category"
                >
                  <template
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen"
                      >{{ values.length }} selected</span
                    ></template
                  >
                </app-multi-select>

                <div class="selected-label" v-if="filter.category.length > 0">
                  FILTER:
                  <div v-for="category in filter.category" :key="category">
                    {{
                      categoryOptions.find((x) => x.id === category).category
                    }}
                  </div>
                </div>
              </div>

              <div class="filter-action">
                <button
                  type="button"
                  class="btn btn-ecdc btn-block"
                  @click="setFilter()"
                >
                  Apply
                </button>
                <button
                  type="button"
                  class="btn btn-link btn-block text-light"
                  @click="clearFilter()"
                >
                  Clear Filter
                </button>
              </div>
            </div>
          </div>
        </transition>

        <div
          id="table-content-col"
          :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'"
        >
          <div
            class="table-options row justify-content-between align-items-center"
          >
            <div class="col-sm">
              <button
                @click="toggleFilter = !toggleFilter"
                type="button"
                class="btn btn-ecdc btn-filter"
              >
                Filter
              </button>

              <!--<div class="table-search form-inline d-inline-block ml-4">-->
              <!--<input type="text" class="form-control" placeholder="Search by keyword">-->
              <!--<button type="button" class="btn btn-ecdc btn-circle">-->
              <!--<app-icon-search></app-icon-search>-->
              <!--</button>-->
              <!--</div>-->
            </div>
            <div class="col-sm mt-sm-0 mt-3">
              <app-paginate
                :page-count="totalPage"
                :click-handler="pagination"
                :prev-text="'&laquo;'"
                :next-text="'&raquo;'"
                ref="paginateTop"
                :container-class="'pagination justify-content-end'"
              >
              </app-paginate>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped table-hover result-table">
              <thead>
                <tr>
                  <th rowspan="2">Venue</th>
                  <th rowspan="2">Area</th>
                  <th rowspan="2">District</th>
                  <th rowspan="2">Category</th>
                  <th rowspan="2">Average Duration</th>
                  <th rowspan="2">Crowd</th>
                  <th rowspan="2">Trial</th>
                  <th rowspan="2" class="border-right border-light">
                    Non Trial
                  </th>
                  <th
                    colspan="5"
                    class="text-center border-bottom border-light"
                  >
                    SOB
                  </th>
                </tr>
                <tr>
                  <th>BENTOEL</th>
                  <th>ROKOK PUTIH</th>
                  <th>MILD</th>
                  <th>SKM</th>
                  <th>SKT</th>
                </tr>
              </thead>

              <tbody>
                <tr :key="data.id" v-for="data in analysisData">
                  <td>{{ data.name }}</td>
                  <td>{{ data.area_name }}</td>
                  <td>{{ data.district }}</td>
                  <td>{{ data.category_name }}</td>
                  <td>{{ convertTime(data.duration) }}</td>
                  <td>{{ data.crowd }}</td>
                  <td>{{ data.trial }}%</td>
                  <td class="border-right border-light">
                    {{ data.non_trial }}%
                  </td>
                  <td>{{ data.sob_bentoel }}%</td>
                  <td>{{ data.sob_rokok_putih }}%</td>
                  <td>{{ data.sob_mild }}%</td>
                  <td>{{ data.sob_skm }}%</td>
                  <td>{{ data.sob_skt }}%</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row justify-content-between align-items-center table-options">
            <div class="col-lg col-6">
              <select
                class="form-control custom-select"
                v-model="pageLimit"
                @change="pagination(1)"
              >
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              per page
            </div>
            <div class="col-lg text-lg-center text-right col-6">
              {{ showingResults }}
            </div>
            <div class="col-lg mt-lg-0 mt-3">
              <app-paginate
                :page-count="totalPage"
                :click-handler="pagination"
                :prev-text="'&laquo;'"
                :next-text="'&raquo;'"
                ref="paginateBottom"
                :container-class="'pagination justify-content-end'"
              >
              </app-paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="area-modal" hide-header hide-footer centered size="xl">
      <img
        src="../assets/img/icon-close.png"
        alt="icon-close"
        class="img-fluid modal-close"
        @click="$bvModal.hide('area-modal')"
      />

      <div class="selection-modal">
        <h4 class="title text-left mb-5">Area</h4>

        <div class="form-group">
          <div class="row">
            <div
              v-for="area in areaOptions"
              v-bind:key="area.id"
              class="col-4 col-xl-2"
            >
              <div class="custom-control custom-checkbox form-check-inline">
                <input
                  class="custom-control-input"
                  type="checkbox"
                  :id="'inlineCheckbox' + area.id"
                  :value="area.id"
                  v-model="filter.area"
                />
                <label
                  class="custom-control-label"
                  :for="'inlineCheckbox' + area.id"
                  >{{ area.name }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-ecdc"
            @click="$bvModal.hide('area-modal')"
          >
            Done
          </button>
          <button
            type="button"
            class="btn btn-link text-muted"
            @click="clearArea()"
          >
            Clear Selection
          </button>
        </div>
      </div>
    </b-modal>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import Loader from "./Loader.vue";
import Paginate from "vuejs-paginate";
// import IconSearch from '../svg/Search.vue'
import {
  getAreas,
  getVenueAnalysisDetails,
  getVenueAnalysisCategories,
} from "../api";
import Multiselect from "vue-multiselect";

export default {
  components: {
    appLoader: Loader,
    appPaginate: Paginate,
    // appIconSearch: IconSearch,
    appMultiSelect: Multiselect,
  },
  data() {
    return {
      filter: {
        area: [],
        category: [],
      },
      areas: [],
      areaOptions: [],
      categories: [],
      categoryOptions: [],
      isLoading: true,
      toggleFilter: true,
      analysisData: "",
      totalPage: 0,
      pageLimit: 15,
      showingResults: "",
    };
  },
  async mounted() {
    await this.getAreas();
    await this.getVenueAnalysisCategories();
    await this.getVenueAnalysisDetails(1);
    this.isLoading = false;
  },
  methods: {
    async getVenueAnalysisDetails(pageNum) {
      try {
        const result = await getVenueAnalysisDetails(
          this.filter,
          pageNum,
          this.pageLimit
        );

        window.constructedData = result.data;
        this.analysisData = result.data.data;
        this.totalPage = result.data.meta.last_page;

        let startPage = 1;
        if (pageNum !== 1) startPage = this.pageLimit * (pageNum - 1) + 1;
        let endPage = pageNum * this.pageLimit;
        if (endPage >= result.data.meta.total) endPage = result.data.meta.total;
        this.showingResults =
          "Showing " +
          startPage +
          " - " +
          endPage +
          " of " +
          result.data.meta.total +
          " results";
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getVenueAnalysisCategories() {
      try {
        const result = await getVenueAnalysisCategories();
        this.categories = result.data.categories;
        this.categoryOptions = this.categories;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async pagination(pageNum) {
      this.isLoading = true;
      if (pageNum !== 0)
        this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
      else pageNum = this.$refs.paginateBottom.selected;

      await this.getVenueAnalysisDetails(pageNum);
      this.isLoading = false;
    },
    async getAreas() {
      try {
        const result = await getAreas();
        this.areas = result.data.data;
        this.areaOptions = this.areas;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    clearArea() {
      this.filter.area = [];
    },
    clearFilter() {
      this.filter.area = [];
      this.filter.category = [];
    },
    async setFilter() {
      this.isLoading = true;
      await this.getVenueAnalysisDetails(1);
      this.isLoading = false;
    },
    convertTime(duration) {
      let minutes = parseInt((duration / (1000 * 60)) % 60);
      let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;

      return hours + " hours " + minutes + " minutes";
    },
  },
};
</script>
